export const getAdjustedRange = (toolCallAdjustments: any, filePath: string, startLine: number, endLine: number) => {
    let offset = 0;
    if (filePath in toolCallAdjustments) {
        const relevantAdjustments = toolCallAdjustments[filePath].filter(
            ([adjustmentStartLine]: [number, number]) => adjustmentStartLine < startLine
        );
        offset = relevantAdjustments.reduce(
            (sum: number, [, fileSizeDiff]: [number, number]) => sum + fileSizeDiff,
            0
        );
    }

    return { adjustedStart: startLine + offset, adjustedEnd: endLine + offset };
}
